import { render } from "./accordion.vue?vue&type=template&id=d3e3b1f6&scoped=true&ts=true"
import script from "./accordion.vue?vue&type=script&lang=ts"
export * from "./accordion.vue?vue&type=script&lang=ts"

import "./accordion.vue?vue&type=style&index=0&id=d3e3b1f6&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3e3b1f6"]])

export default __exports__